export enum RegimeIcmsEnum {
  Monofasico = 1,
  TributacaoIntegral = 2,
}
